import { isD1Configured } from './d1';
import { getBooleanEnv } from '../utils/env';

export interface FeatureFlags {
    useD1Listings: boolean;
    useD1Blog: boolean;
    useD1Auth: boolean;
    useD1Analytics: boolean;
    useD1Reviews: boolean;
    useD1Vendors: boolean;
    reviewsEnabled: boolean;
    favoritesEnabled: boolean;
}

class FeatureService {
    private flags: FeatureFlags;

    constructor() {
        const backendReachable = isD1Configured();

        // Read feature toggles from environment variables with safe defaults.
        // During migration, D1 integration for auth/listings/vendors is true if backend reachable.
        // Optional user-facing features (reviews, favorites, blog) can be toggled via VITE_ENABLE_* env vars.
        this.flags = {
            useD1Listings: backendReachable,
            useD1Blog: backendReachable && getBooleanEnv('VITE_ENABLE_BLOG', false),
            useD1Auth: backendReachable,
            useD1Analytics: backendReachable,
            useD1Reviews: backendReachable,
            useD1Vendors: backendReachable,
            reviewsEnabled: getBooleanEnv('VITE_ENABLE_REVIEWS', false),
            favoritesEnabled: getBooleanEnv('VITE_ENABLE_FAVORITES', false)
        };
    }

    get(): FeatureFlags {
        return this.flags;
    }

    // Allow runtime toggling for testing
    set(key: keyof FeatureFlags, value: boolean) {
        this.flags[key] = value;

    }
}

export const features = new FeatureService();
